import styled from 'styled-components'
import {
  space,
  layout,
  color,
  flexbox,
  position,
  SpaceProps,
  LayoutProps,
  ColorProps,
  PositionProps,
  FlexboxProps,
  ColorStyleProps
} from 'styled-system'
import propTypes from '@styled-system/prop-types'

export type BoxProps = SpaceProps & LayoutProps & ColorStyleProps &  ColorProps & PositionProps & FlexboxProps

const propsToOmit = [
  ...Object.keys(propTypes.space),
  ...Object.keys(propTypes.layout),
  ...Object.keys(propTypes.color),
  ...Object.keys(propTypes.position),
  ...Object.keys(propTypes.flexbox),
]

const Box = styled('div').withConfig({
  shouldForwardProp: (prop) => !propsToOmit.includes(prop as string),
})<BoxProps>`
  ${space}
  ${layout}
  ${color}
  ${position}
  ${flexbox}
`

export default Box
